import React from 'react';
import PropTypes from 'prop-types';

import { ConfirmModal, Link } from '@components';
import { useTranslation } from 'react-i18next';
import { dateDifference } from '@helpers';

const ModalTermsAndConditions = ({
  isLegalAgent,
  isExpired,
  expirationDate,
  handleConfirm,
  handleCancel,
}) => {
  const { t } = useTranslation();

  const getUrl = () => t('common.termsOfService.url');

  const getTitle = () =>
    !isLegalAgent && isExpired
      ? t('common.termsOfService.expiredTitle')
      : t('common.termsOfService.title');

  const getTodayDate = () => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return today;
  };

  const getExpirationDate = () => {
    if (expirationDate) {
      const expiration = new Date(expirationDate.replaceAll('-', '/'));
      expiration.setHours(0, 0, 0, 0);
      return expiration;
    }
    return new Date();
  };

  const getSubtitle = () => {
    const url = getUrl();
    const title = t('common.termsOfService.title');

    if (isLegalAgent && !isExpired) {
      return (
        <>
          {t('common.termsOfService.legalAgent.toBeExpiredNew.0')}
          <Link href={url} target="_blank" rel="noopener noreferrer">
            {t('common.termsOfService.legalAgent.toBeExpiredNew.1', { tos: title })}
          </Link>
          {t('common.termsOfService.legalAgent.toBeExpiredNew.2')}
          <strong>
            {t('common.termsOfService.legalAgent.toBeExpiredNew.3', {
              days: dateDifference(getTodayDate(), getExpirationDate()),
            })}
          </strong>
          {t('common.termsOfService.legalAgent.toBeExpiredNew.4')}
        </>
      );
    }
    if (isLegalAgent && isExpired) {
      return (
        <>
          {t('common.termsOfService.legalAgent.expired.0')}
          <Link href={url} target="_blank" rel="noopener noreferrer">
            {t('common.termsOfService.legalAgent.expired.1', { tos: title })}
          </Link>
          <br />
          {t('common.termsOfService.legalAgent.expired.2')}
        </>
      );
    }

    if (!isLegalAgent && isExpired) {
      return t('common.termsOfService.notLegalAgent.expired');
    }

    return null;
  };

  const getCancel = () => (isLegalAgent ? t('common.cancel') : null);

  const getConfirm = () =>
    isLegalAgent ? t('common.acceptTermsAndConditions') : t('common.continue');

  return (
    <ConfirmModal
      title={getTitle()}
      subTitle={getSubtitle()}
      textConfirm={getConfirm()}
      textCancel={getCancel()}
      open
      extraWidth
      handleCancel={handleCancel}
      handleConfirm={handleConfirm}
      cancelButtonSizeInLargeScreen={4}
      maxWidthButtons={!getCancel()}
      disableDefaultHandleClose
    />
  );
};

ModalTermsAndConditions.propsTypes = {
  isLegalAgent: PropTypes.bool.isRequired,
  isExpired: PropTypes.bool.isRequired,
  handleConfirm: PropTypes.func.isRequired,
  handleCancel: PropTypes.func.isRequired,
  expirationDate: PropTypes.string,
};

ModalTermsAndConditions.defaultProps = {
  expirationDate: '',
};

export default ModalTermsAndConditions;
